<div class="card">
    <div class="ng-Header col-xs-12">
      <i nz-icon nzType="form" nzTheme="outline"></i> Add Officer
    </div>
    <div class="searchboxAerar p-3">
      <form nz-form [formGroup]="officerForm" (ngSubmit)="submitForm()">
        <div class="col-md-9">
          <div class="mb-2 row">
            <div class="col-md-6 col-sm-12 text-right">
              <nz-form-label nzRequired>Name of Officer</nz-form-label>
            </div>
            <div class="col-md-5">
              <nz-form-item>
                <nz-form-control
                  nzHasFeedback
                  class="row"
                  [nzErrorTip]="errorTplForName"
                  [ngClass]="{
                    'is-loading': officerForm.controls['name'].pending
                  }"
                >
                  <input
                    nz-input
                    type="text"
                    id="name"
                    placeholder="Name of officer"
                    formControlName="name"
                  />
                  <ng-template #errorTplForName let-control>
                    <ng-container *ngIf="control.hasError('required')">
                      Please input valid name!
                    </ng-container>
                    <ng-container *ngIf="control.hasError('whitespace')"
                      >Please enter valid name</ng-container
                    >
                  </ng-template>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div class="col-md-6 col-sm-12 text-right">
              <nz-form-label nzRequired>Email</nz-form-label>
            </div>
            <div class="col-md-5">
              <nz-form-item>
                <nz-form-control
                  nzHasFeedback
                  class="row"
                  [nzErrorTip]="errorTplForEmail"
                >
                  <input
                    nz-input
                    type="email"
                    id="email"
                    placeholder="Email for NSDA officer"
                    formControlName="email"
                  />
                  <ng-template #errorTplForEmail let-control>
                    <ng-container *ngIf="control.hasError('required')">
                      Please input valid email!
                    </ng-container>
                    <ng-container *ngIf="control.hasError('whitespace')">
                      Please enter valid email
                    </ng-container>
                    <ng-container *ngIf="control.hasError('email')"
                      >Please enter valid email!
                    </ng-container>
                  </ng-template>
                </nz-form-control>
              </nz-form-item>
            </div>

            <div class="col-md-6 col-sm-12 text-right">
              <nz-form-label nzRequired>Contact Number</nz-form-label>
            </div>
            <div class="col-md-5">
              <nz-form-item>
                <nz-form-control
                  nzHasFeedback
                  class="row"
                  [nzErrorTip]="errorTplForContactNumber"
                >
                  <input
                    nz-input
                    type="text"
                    placeholder="Contact Number"
                    formControlName="phone"
                    (keyup)="checkContactNumberIfExist($event.target)"
                  />
                  <ng-template #errorTplForContactNumber let-control>
                    <ng-container *ngIf="control.hasError('required')">
                      Please input Contact Number!
                    </ng-container>
                    <ng-container *ngIf="control.hasError('pattern')">
                      <div>Contact number must be 11 digits</div>
                    </ng-container>
                    <ng-container *ngIf="contactNumberAlreadyExist" class="text-danger">
                      <div>This contact number already exists !</div>
                    </ng-container>
                  </ng-template>
                </nz-form-control>
              </nz-form-item>
            </div>


          </div>
        </div>
        <div class="row justify-content-center media-button">
          <div class="col-xs-6 col-sm-2">
            <button
              type="submit"
              class="btn btn-success active btn-lg btn-block cari border-redius"
              [disabled]="!officerForm.valid"
            >
              <i nz-icon nzType="save" nzTheme="fill"></i> Save
            </button>
          </div>
          <div class="col-xs-6 col-sm-2">
            <button
              type="button"
              class="btn btn-danger active btn-lg btn-block cari border-redius"
              (click)="resetForm()"
            >
              <i nz-icon nzType="redo" nzTheme="outline"></i> Reset
            </button>
            <br />
          </div>
        </div>
      </form>
    </div>
  </div>
